import { render, staticRenderFns } from "./LoanData.vue?vue&type=template&id=20a59024"
import script from "./LoanData.vue?vue&type=script&lang=js"
export * from "./LoanData.vue?vue&type=script&lang=js"
import style0 from "./LoanData.vue?vue&type=style&index=0&id=20a59024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports